var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-center text-center py-7 mx-auto",staticStyle:{"width":"90vw"}},[_c('v-container',{attrs:{"fluid":""}},[_c('MedlemsData',{attrs:{"memberId":_vm.id}}),_c('MedlemsBetalinger',{attrs:{"memberId":_vm.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }